import { Search, FileText, LayoutGrid, Mic, Image, Clapperboard } from "lucide-react";
import { Chapter, Reveal } from "@/components/landing/Reveal";

const CARDS = [
  { num: "01", title: "Research", desc: "Discover and organize reliable sources.", icon: Search },
  { num: "02", title: "Script", desc: "Transform evidence into a structured narrative.", icon: FileText },
  { num: "03", title: "Storyboard", desc: "Break the story into scenes, narration, and visual direction.", icon: LayoutGrid },
  { num: "04", title: "Narration", desc: "Turn the script into natural voice narration.", icon: Mic },
  { num: "05", title: "Visuals", desc: "Find or generate the visual assets needed for each scene.", icon: Image },
  { num: "06", title: "Assembly", desc: "Combine narration, visuals, music, captions, and timing into the final documentary.", icon: Clapperboard },
];

export default function Vision() {
  return (
    <section id="vision" className="relative bg-[#0C0C0C] py-28 sm:py-36" data-testid="vision-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Chapter index="02" label="The Vision" testid="vision-chapter" />

        <Reveal>
          <h2
            className="max-w-3xl font-display text-3xl font-bold leading-[1.08] tracking-tight sm:text-4xl lg:text-5xl"
            data-testid="vision-section-title"
          >
            A production studio <span className="text-[#D4AF37]">powered by AI.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-[#9A9A9A] sm:text-lg">
          <p>
            pitsora combines AI agents, research tools, creative workflows, and media generation
            into a single production pipeline.
          </p>
          <p>
            Instead of asking AI to simply "write a video," pitsora is being designed as a
            production system. Every stage builds on the previous one.
          </p>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {CARDS.map((card, i) => (
            <Reveal key={card.num} delay={i * 0.08}>
              <div
                className="group relative h-full overflow-hidden border border-white/8 bg-[#111111] p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#D4AF37]/35"
                data-testid={`vision-card-${card.num}`}
              >
                <span
                  className="text-outline pointer-events-none absolute -right-3 -top-6 select-none font-display text-[7rem] font-extrabold leading-none transition-opacity duration-500 group-hover:opacity-60"
                  aria-hidden="true"
                >
                  {card.num}
                </span>
                <div className="relative">
                  <div className="mb-8 flex h-11 w-11 items-center justify-center border border-white/10 text-[#9A9A9A] transition-colors duration-500 group-hover:border-[#D4AF37]/40 group-hover:text-[#D4AF37]">
                    <card.icon className="h-5 w-5" strokeWidth={1.5} />
                  </div>
                  <div className="mb-3 font-mono text-[10px] tracking-[0.3em] text-[#D4AF37]">
                    {card.num}
                  </div>
                  <h3 className="font-display text-xl font-semibold tracking-tight text-[#F5F5F5] sm:text-2xl">
                    {card.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#9A9A9A]">{card.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
